import React, { FunctionComponent } from 'react';

import { Sectors as SectorsType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import { graphql } from 'gatsby';

import BreakpointContainer from '../../BreakpointContainer';
import Buttons from '../../Buttons';
import SectorCard from '../../SectorCard';

export const SectorsFragment = graphql`
  fragment SectorsFragment on SanitySectors {
    title {
      title
      level
    }
    variant {
      variant
    }
    cards {
      title
      icon {
        type
      }
      professions
      href
    }
    ctas {
      ...CtaFragment
    }
  }
`;

const useStyles = () => {
  const { breakpoint, spacing } = useTheme();
  return {
    item: {
      maxWidth: `calc(100% - ${spacing(10)})`,
      margin: spacing(1),
      [breakpoint.up('md')]: {
        maxWidth: `calc(100% - ${spacing(12)})`,
        margin: spacing(2),
      },
    },
  };
};

const Sectors: FunctionComponent<SectorsType> = (props) => {
  const { cards = [], ctas = [] } = props;
  const { level = 'h2', title } = props.title || {};

  const classes = useStyles();

  return (
    <Flex
      css={{ boxSizing: 'border-box' }}
      width="100%"
      flexDirection="column"
      alignItems="center"
      padding={4}
    >
      <BreakpointContainer maxWidth="lg" alignItems="center">
        <Text as={level} variant="headline2" gutter={3} css={{ textAlign: 'center' }}>
          {title}
        </Text>
      </BreakpointContainer>

      <BreakpointContainer
        maxWidth="xl"
        flexDirection={{ xs: 'column', md: 'row' }}
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        margin={[2, -2, 2]}
      >
        {cards.map((sectorCard, index) => {
          return <SectorCard key={index} css={classes.item} {...sectorCard} />;
        })}
      </BreakpointContainer>

      <Buttons ctas={ctas} />
    </Flex>
  );
};

export default Sectors;
